















































import { Component, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import {
  ScheduleFilter,
  ScheduleDateFilter,
  User,
} from "@/store/modules/types";
import { ScheduleType } from "@/store/modules/enums";
import moment from "moment";
import Header from "@/components/Header.vue";

@Component({
  components: {
    Header,
  },
  computed: mapState("auth", ["user"]),
})
export default class Schedule extends Vue {
  user!: User;
  filter!: ScheduleFilter;
  pageRows = Array<any>();
  totalRows = 0;
  types = Array<string>();
  dates = Array<string>();
  selected: any | null = null;
  @Watch("filter", { deep: true })
  onFilterChanged() {
    this.getAppts();
  }
  async getAppts() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      this.$store.commit("schedule/SET_CALENDAR_FILTER", {
        name: "",
        list: this.user.calendars.map((c) => c.id),
      });
      const data = await this.$store.dispatch("schedule/getApptList");
      this.totalRows = data.totalRows;
      this.pageRows = data.pageRows.map((appt) => {
        appt.active = false;
        appt.isService = appt.typeId !== ScheduleType.REGULAR;
        if (appt.serviceAddress) {
          appt.serviceAddress = JSON.parse(appt.serviceAddress);
        }
        return appt;
      });
      // GET DISTINCT TYPES
      this.types = this.pageRows.map((row) => row.typeId);
      this.types = [...new Set(this.types)];
      // GET DISTINCT DATES
      // this.dates = this.pageRows.map((row) => row.date);
      // this.dates = [...new Set(this.dates)];
      //
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  getDatesByType(typeId: string) {
    const dates = this.pageRows
      .filter((row) => row.typeId === typeId)
      .map((row) => row.date);
    return [...new Set(dates)];
  }
  getApptsByTypeAndDate(typeId: string, date: string) {
    return this.pageRows.filter(
      (row) => row.typeId === typeId && row.date === date
    );
  }
  showAppt(appt) {
    this.$router.push({ name: "Appt", params: { id: appt.id } });
  }
  apptTypeTitle(typeId) {
    switch (typeId) {
      case ScheduleType.REGULAR:
        return "Appointments";
      case ScheduleType.SERVICE:
        return "Services";
      case ScheduleType.DELIVERY:
        return "Deliveries";
      case ScheduleType.READY_RESPONDERS:
        return "Ready Responder";
    }
  }
  apptTypeIcon(typeId) {
    switch (typeId) {
      case ScheduleType.REGULAR:
        return "far fa-calendar-alt";
      case ScheduleType.SERVICE:
        return "fas fa-stethoscope";
      case ScheduleType.DELIVERY:
        return "fas fa-truck";
      case ScheduleType.READY_RESPONDERS:
        return "fas fa-user-md";
    }
  }
  get ScheduleType() {
    return ScheduleType;
  }
  mounted() {
    const dateFilter: ScheduleDateFilter = {
      from: moment().toDate(),
      to: moment().add(30, "days").toDate(),
    };
    this.$store.commit("schedule/SET_DATE_FILTER", dateFilter);

    this.getAppts();
  }
}
